import React, { useEffect } from 'react';
import { VideoDownload, HelpVideo } from '~components/svgs';
import { useTranslation } from 'react-i18next';
import event from '~helpers/mixpanel';
import COUNTER_OFFER_HELP_ONE from '~css/imgs/counter-offer-one.png';

const CounterOfferHelp = () => {
  const { t } = useTranslation();
  const videoArr = [
    {
      desc: t('counter.offer.help_modal.accept_video_title'),
      link: "https://s3.ap-southeast-1.amazonaws.com/prod-osl-video.ap-southeast-1/prod-dashboard/Accept%2C+Counter+or+Reject+a+student's+order",
    },
    {
      desc: t('counter.offer.help_modal.deep_video_title'),
      link: 'https://s3.ap-southeast-1.amazonaws.com/prod-osl-video.ap-southeast-1/prod-dashboard/Deep+dive+into+a+Counter+offer',
    },
    {
      desc: t('counter.offer.help_modal.editing_video_title'),
      link: 'https://s3.ap-southeast-1.amazonaws.com/prod-osl-video.ap-southeast-1/prod-dashboard/Editing+a+Counter+Offer',
    },
  ];
  const listArr = [
    t('landlord.new_dashboard.counter-offer-help.tech.one'),
    t('landlord.new_dashboard.counter-offer-help.tech.two'),
    t('landlord.new_dashboard.counter-offer-help.tech.three'),
    t('landlord.new_dashboard.counter-offer-help.tech.four'),
    t('landlord.new_dashboard.counter-offer-help.tech.five'),
    t('landlord.new_dashboard.counter-offer-help.tech.six'),
    t('landlord.new_dashboard.counter-offer-help.tech.seven'),
    t('landlord.new_dashboard.counter-offer-help.tech.eight'),
  ];
  useEffect(() => {
    event('Viewed News in Help Center Page', { 'Function Name': 'Counter Offer' });
  }, []);
  return (
    <div className="counter-offer-help">
      <div className="counter-offer-help__top">
        <h1 className="common__title">{t('landlord.new_dashboard.counter-offer-help.title')}</h1>
        <div className="common__imgbox">
          <img
            src={COUNTER_OFFER_HELP_ONE}
            alt={t('landlord.new_dashboard.counter-offer-help.title')}
          />
        </div>
        <div className="counter-offer-help__info-title">
          {t('landlord.new_dashboard.counter-offer-help.subtitle')}
        </div>
        <ul className="counter-offer-help__info-ul">
          <li>{t('landlord.new_dashboard.counter-offer-help.list_room')}</li>
          <li>{t('landlord.new_dashboard.counter-offer-help.move_in')}</li>
          <li>{t('landlord.new_dashboard.counter-offer-help.special_offer')}</li>
        </ul>
        <div className="counter-offer-help__how-work">
          <div className="counter-offer-help__how-work-title">
            {t('landlord.new_dashboard.counter-offer-help.how_does_work')}
          </div>
          <div className="counter-offer-help__how-work-desc">
            {t('landlord.new_dashboard.counter-offer-help.answer.first')}
          </div>
          <div className="counter-offer-help__how-work-desc">
            {t('landlord.new_dashboard.counter-offer-help.answer.desc')}
          </div>
        </div>
        <ul className="counter-offer-help__how-work-ul">
          <For each="list" of={listArr} index="index">
            <li key={index}>{list}</li>
          </For>
        </ul>
        <div className="counter-offer-help__how-work-desc">
          {t('landlord.new_dashboard.counter-offer-help.end')}
        </div>
      </div>
      <div className="counter-offer-help__bottom">
        <div className="counter-offer-help__bottom-contents">
          <div className="counter-offer-help__resource-title">
            {t('landlord.new_dashboard.counter-offer-help.resource.title')}
          </div>
          <div className="counter-offer-help__video-wrap">
            <For each="item" of={videoArr}>
              <div className="counter-offer-help__videobox">
                <div>
                  <HelpVideo className="counter-offer-help__videoIcon" />
                  <span className="counter-offer-help__video-title">
                    {t('landlord.new_dashboard.counter-offer-help.resource.video')}
                  </span>
                </div>
                <div className="counter-offer-help__video-content">{item.desc}</div>
                <a href={item.link} download>
                  <VideoDownload className="counter-offer-help__download-icon" />
                  <span className="counter-offer-help__download-word">
                    {t('landlord.new_dashboard.counter-offer-help.resource.down')}
                  </span>
                </a>
              </div>
            </For>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CounterOfferHelp;
